import type {
  WarehouseRecords,
  WiredRecordsByModel,
} from "@/components/ecv2/state/surfaces/warehouseSurface";
import type { ModelName } from "@/endlaFunctions/customTypings/ecTypes";
import type { Atom, Getter } from "jotai";

export type EcRowsSource = {
  recordsAtom?: Atom<WarehouseRecords | null>;
  wiredRecords?: WiredRecordsByModel;
};

/**
 * The rows an EC owns for `model`: its single emission when that carries the
 * model, else its records array's fold for the model. `null` means the EC
 * takes rows over a wire but none carry this model yet, so the rows are
 * empty; `undefined` means the EC has no rows contract for this model (no
 * contract at all, or a single emission of another model) and the caller
 * may fall back to the model's warehouse rows.
 */
export function ecRowsForModel(
  get: Getter,
  source: EcRowsSource,
  model: ModelName
): WarehouseRecords | null | undefined {
  if (source.recordsAtom) {
    const emission = get(source.recordsAtom);
    if (emission === null) {
      return null;
    }
    if (emission.model === model) {
      return emission;
    }
  }
  if (source.wiredRecords) {
    return get(source.wiredRecords.byModel.get(model)) ?? null;
  }
  return undefined;
}
